import { apiClient } from './client';

export interface RequestObservationSummary {
  loop_request_id: string;
  observed_at: string;
  method: string;
  route_template: string;
  status_code: number;
  api_version: string | null;
  auth_type: string;
}

export interface RequestObservationListResponse {
  requests: RequestObservationSummary[];
  next_page_url: string | null;
  previous_page_url: string | null;
}

export interface GetRequestsParams {
  cursor?: string;
  limit?: number;
  sort_order?: 'asc' | 'desc';
  status_class?: string;
  observed_at_after?: string;
  observed_at_before?: string;
  method?: string;
  route_template?: string;
  global_order_id?: number;
}

export function getRequests (shopId: number | string, params: GetRequestsParams = {}) {
  return apiClient.get<RequestObservationListResponse>(`/${shopId}/observability/requests`, { params });
}

export interface RequestObservation {
  loop_request_id: string;
  request_started_at: string;
  observed_at: string;
  method: string;
  route_template: string;
  request_path: string;
  status_code: number;
  api_version: string | null;
  auth_type: string;
  shop_id: number | null;
  global_order_id: number | null;
  return_id: number | null;
  api_key_id: number | null;
  authorized_client_id: string | null;
  capture_profile: string;
  is_request_body_captured: boolean;
  is_response_body_captured: boolean;
  logs_count: number;
  is_request_truncated: boolean | null;
  is_response_truncated: boolean | null;
  is_exception_truncated: boolean | null;
}

// Fields optional: the byte cap can drop the trace, or most of the snapshot.
export interface RequestObservationException {
  class?: string;
  message?: string;
  code?: number | string;
  file?: string;
  line?: number;
  trace?: Array<Record<string, unknown>>;
}

export interface RequestObservationDetailRow {
  request_content_type: string | null;
  request_headers: Record<string, unknown> | null;
  request_query: Record<string, unknown> | null;
  request_route_params: Record<string, string | null> | null;
  request_payload: unknown;
  response_content_type: string | null;
  response_payload: unknown;
  validation_errors: Record<string, unknown> | null;
  exception: RequestObservationException | null;
}

export interface RequestObservationLog {
  logged_at: string;
  sequence: number;
  level: string;
  message: string;
  context: Record<string, unknown> | null;
}

export interface RequestObservationDetailResponse {
  request: RequestObservation;
  detail: RequestObservationDetailRow | null;
  logs: RequestObservationLog[];
}

export function getRequest (shopId: number | string, loopRequestId: string) {
  return apiClient.get<RequestObservationDetailResponse>(
    `/${shopId}/observability/requests/${encodeURIComponent(loopRequestId)}`,
  );
}

// The list endpoint paginates by opaque cursor: each response carries the full
// next/previous page URLs. Pull the `cursor` param back out so we can re-request
// through the typed service rather than hitting the raw URL.
export function extractCursor (pageUrl: string | null): string | null {
  if (!pageUrl) {
    return null;
  }

  try {
    return new URL(pageUrl, window.location.origin).searchParams.get('cursor');
  } catch {
    return null;
  }
}
